import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import { createSelector } from '@reduxjs/toolkit'
import type { RootState, AppDispatch } from './store'

// Use throughout your app instead of plain `useDispatch` and `useSelector`
type DispatchFunc = () => AppDispatch
export const useAppDispatch: DispatchFunc = useDispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
export const createAppSelector = createSelector.withTypes<RootState>()